<template>
  <div class="lb-table">
    <div class="table-filter-box" v-if="showFilter">
      <b-set-column
        :columns="newColumn"
        @changeColumn="changeColumn"
        @resetColumn="resetColumn"
        :tableNumber="tableNumber"
      ></b-set-column>
    </div>
    <el-table
      :border="true"
      ref="elTable"
      class="blank-table"
      v-bind="$attrs"
      v-on="$listeners"
      v-loading="$attrs.loading"
      :data="data"
      :span-method="this.merge ? this.mergeMethod : this.spanMethod"
      @header-dragend="headerDragend"
    >
      <el-table-column
        v-if="flage"
        type="selection"
        width="30"
        :fixed="fixedCheckbox"
        class="checkbox-column"
      ></el-table-column>
      <lb-column
        v-bind="$attrs"
        v-for="(item, index) in newColumn"
        :key="index"
        :column="item"
      ></lb-column>
      <template slot="empty" v-if="!$attrs.loading">
        <slot name="myEmpty">
          <template v-if="noIcon">
            <div style="margin-top: 60px">暂无数据</div>
          </template>
          <template v-else>
            <img
              style="margin-top: 80px"
              src="@/assets/imgs/no-data-table.png"
            />
            <!--        <img :style="{'margin-top':emptyTop+'px'}" src="@/assets/imgs/no-data-table.png">-->
            <p>暂无数据</p>
          </template>
        </slot>
      </template>
    </el-table>
    <el-pagination
      class="lb-table-pagination"
      v-if="pagination"
      v-bind="$attrs"
      v-on="$listeners"
      @current-change="paginationCurrentChange"
      :style="{ 'margin-top': paginationTop, 'text-align': paginationAlign }"
    ></el-pagination>
  </div>
</template>

<script>
import LbColumn from "./BColumn";
import BSetColumn from "./BSetColumn";
import { openApi } from "./services";
export default {
  props: {
    column: Array,
    data: Array,
    spanMethod: Function,
    tableNumber: {
      type: String,
      default: "",
    },
    pagination: {
      type: Boolean,
      default: false,
    },
    paginationTop: {
      type: String,
      default: "15px",
    },
    paginationAlign: {
      type: String,
      default: "right",
    },
    merge: Array,
    showFilter: {
      type: Boolean,
      default: true,
    },
    noIcon: {
      type: Boolean,
      default: () => false,
    },
    // 次参数控制复选框显示与否  true（显示） false（隐藏）
    flage: {
      type: Boolean,
      default: () => false,
    },
    //是否固定列表复选列
    fixedCheckbox: {
      type: Boolean,
      default: () => true,
    },
  },
  components: {
    LbColumn,
    BSetColumn,
  },
  name: "BTable",
  data() {
    return {
      deleteVisible: false,
      mergeLine: {},
      mergeIndex: {},
      newColumn: [],
    };
  },
  created() {
    this.setColumn();
    this.getMergeArr(this.data, this.merge);
  },
  computed: {
    dataLength() {
      return this.data.length;
    },
  },
  methods: {
    headerDragend(newWidth, oldWidth, column, event) {
      if (newWidth < 100) {
        column.width = 100;
        column.showOverflowTooltip = false;
        setTimeout(function () {
          column.showOverflowTooltip = true;
        }, 100);
      }
    },
    async setColumn() {
      let { obj } = await openApi.getTableHeader(this.tableNumber);
      if (obj && obj.length > 0) {
        let newObj = obj.map((item) => {
          return {
            field: item.field,
            fixed: item.fixed,
            show: item.show == "1" ? true : false,
          };
        });
        this.column.forEach((items) => {
          let isNewCol = true;
          let newItem = {};
          newObj.forEach((item) => {
            if (item.field == items.field) {
              Object.assign(newItem, items, item);
              this.newColumn.push(newItem);
              isNewCol = false;
            }
          });
          if (isNewCol) {
            newItem = { show: true, fixed: null };
            Object.assign(newItem, items);
            this.newColumn.push(newItem);
          }
        });
      } else {
        this.column.forEach((item) => {
          let newItem = { show: true, fixed: null };
          Object.assign(newItem, item);
          this.newColumn.push(newItem);
        });
      }
      this.newColumn[this.newColumn.length - 1].fixed = "right";
      // this.newColumn.forEach((item) => {
      //   if (item.field == "action") {
      //     item.fixed = "right";
      //   }
      // });
    },
    changeColumn(val) {
      this.newColumn = [];
      this.$nextTick(() => {
        this.newColumn = val;
      });
    },
    resetColumn() {
      this.newColumn = [];
      this.column.forEach((item) => {
        let newItem = { show: true, fixed: null };
        Object.assign(newItem, item);
        // if (item.field == "action") {
        //   newItem.fixed = "right";
        // }
        this.newColumn.push(newItem);
      });
      this.newColumn[this.newColumn.length - 1].fixed = "right";
    },
    clearSelection() {
      this.$refs.elTable.clearSelection();
    },
    toggleRowSelection(row, selected) {
      this.$refs.elTable.toggleRowSelection(row, selected);
    },
    toggleAllSelection() {
      this.$refs.elTable.toggleAllSelection();
    },
    toggleRowExpansion(row, expanded) {
      this.$refs.elTable.toggleRowExpansion(row, expanded);
    },
    setCurrentRow(row) {
      this.$refs.elTable.setCurrentRow(row);
    },
    clearSort() {
      this.$refs.elTable.clearSort();
    },
    clearFilter(columnKey) {
      this.$refs.elTable.clearFilter(columnKey);
    },
    doLayout() {
      this.$refs.elTable.doLayout();
    },
    sort(prop, order) {
      this.$refs.elTable.sort(prop, order);
    },
    paginationCurrentChange(val) {
      this.$emit("p-current-change", val);
    },
    getMergeArr(tableData, merge) {
      if (!merge) return;
      this.mergeLine = {};
      this.mergeIndex = {};
      merge.forEach((item, k) => {
        tableData.forEach((data, i) => {
          if (i === 0) {
            this.mergeIndex[item] = this.mergeIndex[item] || [];
            this.mergeIndex[item].push(1);
            this.mergeLine[item] = 0;
          } else {
            if (data[item] === tableData[i - 1][item]) {
              this.mergeIndex[item][this.mergeLine[item]] += 1;
              this.mergeIndex[item].push(0);
            } else {
              this.mergeIndex[item].push(1);
              this.mergeLine[item] = i;
            }
          }
        });
      });
    },
    mergeMethod({ row, column, rowIndex, columnIndex }) {
      const index = this.merge.indexOf(column.property);
      if (index > -1) {
        const _row = this.mergeIndex[this.merge[index]][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
  watch: {
    merge() {
      this.getMergeArr(this.data, this.merge);
    },
    dataLength() {
      this.getMergeArr(this.data, this.merge);
    },
  },
};
</script>
<style lang="scss" scoped>
.lb-table {
  background-color: #ffffff;
  position: relative;
  .table-filter-box {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    z-index: 99;
    text-align: right;
    padding: 6px;
  }
}
</style>
<style lang="scss">
.lb-table {
  .el-table-column--selection {
    border-left: none !important;
    .cell {
      padding: 0 !important;
      display: flex;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Table/BTable.vue